<template>
  <section id="branch-employees-table">
    <h5>По QR-коду ниже доступна общая страница с выбором сотрудника</h5>
    <p v-if="!img">
      Не удалось загрузить QR-Код
    </p>
    <div
      v-else
      :class="['img_wrapper', {
        'shadow': img
      }]"
      v-html="img"
    ></div>
    <div class="mt-6 mb-6">
      <vs-button
        @click="download_qr_code"
        color="primary"
        type="filled"
      >
        Скачать QR-код
      </vs-button>
      &emsp;
      <vs-button
        color="primary"
        type="border"
        :href="link"
        target="_blank"
        @click="toCommonPage"
      >
        Перейти на страницу
      </vs-button>
    </div>
    <p>
      Добавьте логотип заведения на вкладке
      <vs-button
        @click="toProfilePage"
        type="flat"
      >
        Профиль
      </vs-button>
    </p>
  </section>
</template>

<script>
import ApiService from '@/common/api.service'
import { UPDATE_CURRENT_BRANCH_ID } from '@/store/mutations.types'

export default {
  name: 'ModalQr',
  data() {
    return {
      img: null,
      link: null
    }
  },
  methods: {
    async download_qr_code() {
      this.$km_track('CommonPage', 'Click', 'DownloadQR')
      await ApiService.download_file(`branch_page_qr/${this.$route.params.id}`)
    },
    toCommonPage() {
      this.$km_track('CommonPage', 'Click', 'toCommonPage')
    },
    toProfilePage() {
      this.$km_track('CommonPage', 'Click', 'toProfilePage')
      this.$router.push({ name: 'branchDetailProfile' })
    }
  },
  async mounted() {
    this.$store.commit(UPDATE_CURRENT_BRANCH_ID, this.$route.params.id)
    const { data } = await ApiService.get(`branch_page_qr/${this.$route.params.id}/?data=1`)
    if (data) {
      this.img = data.img
      this.link = data.link
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/vuesax/_variables.scss';

  .img_wrapper  {
    margin: $size-2 0 $size-3;
    padding: $size-2;

    &,
    &::v-deep img{
      max-width: 250px;
      width: 100%;
    }
  }
</style>
